import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-missing-h1',
    templateUrl: './missing-h1.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoMissingH1Component {
}
